const assets = {
  bg: require('assets/bg.png'),
  logo: require('assets/logo.png'),
  doctor: require('assets/doctor.png'),
  texture: require('assets/texture.png'),
  arrow: require('assets/arrow@2x.png'),
  mcci: require('assets/mcci@2x.png')
}

export default assets;